module.exports = __webpack_public_path__ + "img/paw-simple.9eee9570.svg";